module.exports = __webpack_public_path__ + "static/logo-4be4ac96dbcea66ae63d39208d291b12.svg";